const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const BlankEngine = require("./BlankEngine");
const WonkyButton = require("./WonkyButton");
const CopyTable = require("../../core/util/CopyTable");
const AssetsUtil = require("../../core/util/AssetsUtil");
const URLMake = require("../../../shared/URLMake");

const styles = require("./styles/ReactPageTrainerError.css");

module.exports = createReactClass({
	displayName: "ReactPageTrainerError",

	propTypes: {
		isInEngineComp: PT.bool,
		noProblems: PT.bool,
		doesNotExist: PT.bool,
		initErrored: PT.bool,
		isReactCrash: PT.bool,
		outOfMemory: PT.bool,
		locked: PT.bool,
		unlocksAt: PT.string,
		problemType: PT.oneOf(["standard", "history", "trophy"]),
		buttonInfo: PT.object,
		inModal: PT.bool,
	},

	render: function() {
		const {isReactCrash, buttonInfo, inModal} = this.props;
		const message = CopyTable.forReactPageError(this.props);

		let buttonEl = null;
		if (!inModal) {
			if (buttonInfo) {
				if (buttonInfo.linkTo) {
					buttonEl = (
						<WonkyButton
							className={styles.button}
							linkTo={buttonInfo.linkTo}
							buttonType={buttonInfo.type}
							buttonText={buttonInfo.text}
						/>
					);
				} else {
					buttonEl = (
						<WonkyButton
							className={styles.button}
							linkTo={URLMake.forHome()}
							buttonType={"home"}
						/>
					);
				}
			} else if (isReactCrash) {
				buttonEl = (
					<WonkyButton
						className={styles.buttonHome}
						linkTo={URLMake.forHome()}
						buttonImageSrc={AssetsUtil.getButton("home", "white")}
						buttonImageSize={3}
						buttonType="home"
					/>
				);
			}
		}

		const outerClass = inModal ? styles.modalPosition : null;

		return (
			<BlankEngine
				className={outerClass}
				isInEngineComp={this.props.isInEngineComp}
			>
				<div className={styles.container}>
					<img className={styles.image} src={AssetsUtil.getGotProblems()} />
					<div className={styles.message}>{message}</div>
				</div>
				{buttonEl}
			</BlankEngine>
		);
	},
});
